import styled, { css } from 'styled-components';
import { Box } from '../../foundation/Box/index.js';
import { themeGet, themeGetColor } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';

var disabledStyles = css(["color:", ";background-color:", ";"], themeGet('colors.disabled.300'), themeGet('colors.gray.50'));
var selectedStyles = css(["background-color:", ";&:hover{background-color:", ";}> [data-icon='falcon']{color:", ";}"], themeGet('colors.primary.50'), themeGet('colors.primary.50'), themeGet('colors.primary.1000'));
var ListItem = styled.div.withConfig({
  displayName: "ListItem",
  componentId: "sc-fls5zz-0"
})(["display:flex;flex-shrink:0;width:100%;padding:", " ", ";align-items:center;justify-content:flex-start;column-gap:", ";user-select:none;border:none;outline:", " solid transparent;background-color:", ";border-radius:", ";text-align:left;color:", ";font-size:", ";font-weight:", ";text-decoration:none;line-height:1;transition-duration:0.2s;transition-property:border,background-color,outline;transition-timing-function:ease-out;&:not(:disabled,[disabled]){cursor:pointer;}&:hover:not(:disabled,[disabled]){background-color:", ";> [data-icon='falcon']{color:", ";}}&:focus-visible{outline:", " solid ", ";}&:active:not(:disabled,[disabled]){background-color:", ";}> [data-icon='falcon']{width:", ";height:", ";color:", ";}", ";", ";"], themeGet('spacing.lg'), themeGet('spacing.md'), themeGet('spacing.md'), themeGet('spacing.sm'), themeGet('colors.background.50'), themeGet('borderRadius.md'), themeGet('colors.text.300'), themeGet('fontSize.medium'), themeGet('fontWeight.regular'), themeGet('colors.primary.50'), themeGet('colors.primary.1000'), themeGet('spacing.sm'), themeGet('colors.focus.primary'), themeGet('colors.focus.primary'), pxToRem(16), pxToRem(16), themeGet('colors.primary.500'), function (_ref) {
  var disabled = _ref.disabled;
  return disabled && disabledStyles;
}, function (_ref2) {
  var $selected = _ref2.$selected,
    disabled = _ref2.disabled;
  return $selected && !disabled && selectedStyles;
});
var List = styled.section.withConfig({
  displayName: "List",
  componentId: "sc-fls5zz-1"
})(["display:flex;flex-direction:column;min-width:", ";padding:", " 0;background-color:", ";gap:", ";"], pxToRem(224), themeGet('spacing.sm'), themeGet('colors.background.50'), themeGet('spacing.sm'));
var ListItemDivider = styled.hr.withConfig({
  displayName: "ListItemDivider",
  componentId: "sc-fls5zz-2"
})(["border:none;margin:", " ", ";height:", ";background-color:", ";"], themeGet('spacing.xs'), themeGet('spacing.md'), pxToRem(1), themeGetColor('border.100', 0.5));
var StickyHeaderContainer = styled(Box).withConfig({
  displayName: "StickyHeaderContainer",
  componentId: "sc-fls5zz-3"
})(["position:", ";top:0;z-index:", ";background-color:", ";"], function (props) {
  return props.$sticky ? 'sticky' : 'relative';
}, function (props) {
  return props.$sticky ? '2' : '1';
}, themeGetColor('gray.0'));
var HeaderActions = styled.div.withConfig({
  displayName: "HeaderActions",
  componentId: "sc-fls5zz-4"
})(["margin-left:auto;"]);
var StickyFooterContainer = styled(Box).withConfig({
  displayName: "StickyFooterContainer",
  componentId: "sc-fls5zz-5"
})(["position:", ";bottom:0;background-color:", ";"], function (props) {
  return props.$sticky ? 'sticky' : 'relative';
}, themeGet('colors.gray.0'));

export { HeaderActions, List, ListItem, ListItemDivider, StickyFooterContainer, StickyHeaderContainer };
